import { createFileRoute } from "@tanstack/react-router";
import { Lists } from "../../app/views/lists";

export const Route = createFileRoute("/feed/lists")({
  component: Lists,
});
